import { useCallback } from "react";
import { useToast } from "@/hooks/use-toast";

/** Provider identities stay in diagnostics, not user-facing system messages. */
export function adsManagerDisplayText(text: string): string {
  return text
    .replace(/Budget update acknowledged by Windsor/gi, "Budget update acknowledged")
    .replace(/Windsor confirmed/gi, "Update acknowledged")
    .replace(/Windsor reporting/gi, "Reporting")
    .replace(/\bWindsor(?:\.ai)?\b/gi, "ad service");
}

export function useAdsManagerToast() {
  const { toast } = useToast();
  return useCallback((props: Parameters<typeof toast>[0]) => toast({
    ...props,
    title: typeof props.title === "string" ? adsManagerDisplayText(props.title) : props.title,
    description: typeof props.description === "string" ? adsManagerDisplayText(props.description) : props.description,
  }), [toast]);
}
